<!-- Loading analizando Lance -->
<div
  class="card-bid orange center"
  *ngIf="!loading && analizing_bid && is_live === 'LIVE'"
>
  <div class="loading">
    <div class="scale">
      <page-loading></page-loading>
    </div>
  </div>

  <div class="left">
    <h3>Aguarde...</h3>
    <h4>seu lance está sendo analisado</h4>
  </div>
</div>

<!-- PRE_LANCE - Após o tempo acabar -->
<!-- <div
  class="card-bid orange"
  *ngIf="
    !loading &&
    is_live === 'DETAILS' &&
    !analizing_bid &&
    animal_obj.type === 'LEILAO ONLINE' &&
    animal_obj.status !== 'VENDIDO' &&
    bid_status === 'FINISH'
  "
>
  <div class="left">
    <h4>Pré Lance Finalizado</h4>
    <h1>{{ attual_bid | currency : 'BRL' }}</h1>
  </div>
</div> -->
<div
  class="card-bid orange"
  *ngIf="
    !loading &&
    is_live === 'DETAILS' &&
    !analizing_bid &&
    animal_obj.type === 'LEILAO ONLINE' &&
    animal_obj.status !== 'VENDIDO' &&
    bid_status === 'FINISH'
  "
>
  <div class="left">
    <h4>Pré Lance Finalizado</h4>
    <h1>{{ attual_bid | currency : 'BRL' }}</h1>
  </div>
</div>

<!-- LANCE - Lote marcado como vendido -->
<div
  class="card-bid orange"
  *ngIf="
    !loading &&
    is_live === 'LIVE' &&
    !analizing_bid &&
    animal_obj.type === 'LEILAO ONLINE' &&
    animal_obj.status === 'VENDIDO' &&
    bid_status !== 'CLOSED' &&
    auction_bid?.id
  "
>
  <div class="left">
    <h4>Lance Atual</h4>
    <h1>{{ attual_bid - increment | currency : 'BRL' }}</h1>
  </div>
</div>

<!-- LANCE - Lote sem encedor -->
<div
  class="card-bid orange"
  *ngIf="
    !loading &&
    is_live === 'LIVE' &&
    !analizing_bid &&
    animal_obj.type === 'LEILAO ONLINE' &&
    animal_obj.status === 'VENDIDO' &&
    bid_status !== 'CLOSED' &&
    !auction_bid?.id
  "
>
  <div class="left">
    <!-- <h4>Sem Vencedor</h4> -->
  </div>
</div>

<!-- PRE_LANCE - Lote aberto para pre lance 2 -->
<div
  class="card-bid orange"
  *ngIf="
    !loading &&
    is_live === 'DETAILS' &&
    animal_obj.type === 'LEILAO ONLINE' &&
    animal_obj.status !== 'VENDIDO' &&
    (bid_status === 'CLOSED' || bid_status === 'REAL_TIME')
  "
>
  <div class="left">
    <h4>Próximo Lance</h4>
    <h1>{{ attual_bid | currency : 'BRL' }}</h1>
  </div>

  <div class="right">
    <!-- Timer do Leilão Online -->
    <!-- <div class="stopwatch" *ngIf="bid_status === 'CLOSED' && time.min < 3">
      <strong> {{ time.min }} Min {{ time.seg }} Seg </strong>
      <app-stopwatch></app-stopwatch>
    </div> -->

    <!-- Pre Lance -->
    <button
      mat-button
      class="c_white"
      (click)="openPopupPreBid()"
      *ngIf="!winning"
    >
      DAR PRÉ LANCE
    </button>
    <div *ngIf="winning" style="width: 100%; height: 30px"></div>
  </div>
</div>

<!-- LANCE - Lance Atual -->
<div
  class="card-bid"
  [ngClass]="!winning ? 'white' : 'green'"
  *ngIf="
    !loading &&
    !analizing_bid &&
    animal_obj.type === 'LEILAO ONLINE' &&
    list_bids.length > 0 &&
    ['REAL_TIME', 'CLOSED'].includes(bid_status)
  "
>
  <div class="left">
    <h4 *ngIf="!winning">Lance Atual</h4>
    <h4 *ngIf="winning">Seu lance esta vencendo!</h4>

    <div class="winning-bid">
      <i icon="check" *ngIf="winning"></i>
      <h5>{{ list_bids[0].value | currency : 'BRL' }}</h5>
      <h5>{{ list_bids[0].updated_at | date : 'dd/MM/yyyy HH:mm a' }}</h5>
    </div>
  </div>
</div>

<!-- COMPRA - Lote aberto para compra -->
<div
  class="card-bid orange"
  *ngIf="
    !loading &&
    (is_live === 'LIVE' ||
      (animal_obj.type === 'SHOPPING' && animal_obj.status !== 'VENDIDO'))
  "
>
  <div class="left">
    <h4>Valor de Compra</h4>
    <h1>{{ animal_obj.bid | currency : 'BRL' }}</h1>
  </div>

  <div class="right">
    <!-- Tipo Shopping  -->
    <button
      mat-button
      class="c_white"
      (click)="openPopupBuyShopping()"
      *ngIf="is_login"
    >
      Comprar
    </button>
    <!-- Usuário não logado -->
    <button
      mat-button
      class="c_white"
      (click)="openPopuplogIn()"
      *ngIf="!is_login"
    >
      Comprar
    </button>
  </div>
</div>

<!-- COMPRA - Lance vendido -->
<div
  class="card-bid green center"
  *ngIf="!loading && animal_obj.status === 'VENDIDO'"
>
  <div class="left">
    <h4>Vendido</h4>
    <h1>{{ attual_bid - increment | currency : 'BRL' }}</h1>
  </div>
</div>
